<template>
  <div class="modal-wrapper copy-move-modal" :class="{ 'modal-copy': action === 'copy' }">
    <div class="modal">
      <div class="modal-header">
        <h1 v-if="action === 'copy'">Изберете дните, на които да копирате отчета:</h1>
        <h1 v-if="action === 'move'">Изберете ден, на който да преместите отчета:</h1>
        <span class="mck modal-close" @click="close(false)">F</span>
      </div>
      <div class="modal-content">
        <datepicker
          :language="bg"
          :inline="true"
          :monday-first="true"
          :minimumView="'day'"
          :maximumView="'day'"
          :full-month-name="true"
          :highlighted="selected"
          @selected="selectDate"
          @changedMonth="changedMonth"
          v-model="date"
        ></datepicker>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()">
          <span class="mck">Y</span>
          <template v-if="action === 'copy'">Копирай</template>
          <template v-if="action === 'move'">Премести</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { bg } from 'vuejs-datepicker/dist/locale';
import { format } from "date-fns";
export default {
  components: {
    Datepicker: Datepicker,
  },
  props: ['action', 'id', 'initialDate'],
  data() {
    return {
      bg: bg,
      months: [
        'Януари',
        'Февруари',
        'Март',
        'Април',
        'Май',
        'Юни',
        'Юли',
        'Август',
        'Септември',
        'Октомври',
        'Ноември',
        'Декември',
      ],
      date: undefined,
      selected: {
        dates: [],
        additional: [],
      },
      report: {
        date: undefined,
      },
      today: undefined,
    };
  },
  methods: {
    changedMonth(m) {
      this.getExisting(m);
    },
    selectDate(date) {
      if (this.action === 'copy') {
        for (let [index, d] of this.selected.dates.entries()) {
          const slct = `${d.getDate()}/${d.getMonth()}/${d.getFullYear()}`;
          const nw = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;

          if (slct === nw) {
            this.selected.dates.splice(index, 1);

            // const selected = document.querySelector('span.cell.day.selected');
            // console.log(selected);

            return;
          }
        }
        this.$nextTick(() => {
          this.selected.dates.push(date);
        });
      }
    },
    getExisting(d) {
      this.selected.additional = [];
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/report/planned-reports-list`;
      if (d) {
        requestUrl += `?date=${d}`;
      }
      this.$http
        .get(requestUrl)
        .then((response) => {
          if (response.data.length) {
            response.data[0].dates.map((d) => {
              this.selected.additional.push(new Date(d));
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    getReport() {
      this.$store.dispatch('startLoading');
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/report/${this.id}`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.report = response.data;
          this.$store.dispatch('stopLoading');
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch('stopLoading');
          this.$snotify.error(`Нещо се обърка`);
          this.close(false);
        });
    },
    validateReport(d) {
      const obj = Object.assign({}, this.report);
      obj.date = d.toISOString();

      if (d.getTime() < this.today.getTime()) {
        return new Promise((res, rej) =>
          rej('Не можете да създавате планиран отчет с минала дата!')
        );
      }

      let url = `${process.env.VUE_APP_BASE_URI}/report/validate-report?self=true`;
      return this.$http.post(url, obj);
    },
    save() {
      if (this.action === 'move') {
        this.validateReport(this.date)
          .then((a) => {
            if (a.data.errors) {
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            }
            if (a.data.exists.length) {
              for (let i = 0; i < a.data.exists.length; i++) {
                this.$snotify.error(
                  `${a.data.exists[i].workers.name} е вече добавен/а към друг отчет в диапазона ${a.data.exists[i].workers.startHour} - ${a.data.exists[i].workers.endHour}`
                );
              }
            } else {
              this.move();
            }
          })
          .catch((err) => {
            if (typeof err === 'string') {
              this.$snotify.error(err);
            } else {
              console.log(err);
              this.$snotify.error('Нещо се обърка!');
            }
          });
      } else if (this.action === 'copy') {
        const promises = [];

        for (let d of this.selected.dates) {
          const p = new Promise((res, rej) => {
            this.validateReport(d)
              .then((a) => {
                if (a.data.errors) {
                  rej('Нещо се обърка! Моля опитайте отново.');
                }
                if (a.data.exists.length) {
                  for (let i = 0; i < a.data.exists.length; i++) {
                    rej(
                      `${
                        a.data.exists[i].workers.name
                      } е вече добавен/а към друг отчет в диапазона ${
                        a.data.exists[i].workers.startHour
                      } - ${a.data.exists[i].workers.endHour} на ${format(new Date(a.data.exists[i].date), 'dd/MM/yyyy')}`
                    );
                  }
                } else {
                  res();
                }
              })
              .catch((err) => {
                rej(err);
              });
          });

          promises.push(p);
        }

        Promise.all(promises)
          .then(() => {
            this.copy();
          })
          .catch((err) => {
            if (typeof err === 'string') {
              this.$snotify.error(err);
            } else {
              console.log(err);
              this.$snotify.error('Нещо се обърка!');
            }
          });
      }
    },
    copy() {
      if (!this.selected.dates.length) {
        this.$snotify.error('Трябва да изберете поне един ден!');
        return;
      }
      const url = `${process.env.VUE_APP_BASE_URI}/report`;
      const promises = [];

      delete this.report._id;

      for (let d of this.selected.dates) {
        const r = Object.assign({}, this.report);
        r.date = d.toISOString();

        const p = new Promise((res, rej) => {
          this.$http
            .post(url, r)
            .then(() => {
              res();
            })
            .catch((error) => {
              rej(error);
            });
        });

        promises.push(p);
      }

      Promise.all(promises)
        .then(() => {
          const count = this.selected.dates.length;
          this.$snotify.success(
            `Успешно копиран планиран отчет за ${count} ${
              count === 1 ? 'ден' : 'дни'
            }!`
          );
          this.close(true);
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    move() {
      this.report.date = this.date.toISOString();

      const url = `${process.env.VUE_APP_BASE_URI}/report/${this.report._id}`;
      this.$http
        .put(url, this.report)
        .then(() => {
          this.$snotify.success(
            `Успешно преместен планиран отчет на ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
          this.close(true);
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    close(update) {
      this.selected.dates = [];
      this.$emit('closeCopyMoveReportModal', { updated: update });
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        this.save();
      } else if (e.code === 'Escape') {
        this.close(false);
      }
    },
  },
  mounted() {
    this.today = new Date();
    this.today.setHours(23, 59, 59, 999);

    this.getExisting();
    this.getReport();
    this.date = new Date();
    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  },
};
</script>

<style scoped>
.modal {
  width: initial;
}
.modal-header {
  justify-content: flex-start;
  padding: 0 30px;
}
.modal-header h1 {
  color: #fff;
  font-size: 20px;
}
.modal-footer {
  justify-content: center;
}
.btn {
  margin: 0;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
